import { Button, Grid, IconButton, Typography } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { format } from "date-fns";
import { useRef, useState } from "react";
import { Calendar } from "../../../../shared/components/calendar";
import { daysMonth } from "../../../../shared/components/calendar/calendar.constants";
import { useOutsideClick } from "../../../../shared/hooks/use-outside-click";
import { useStyles } from "./schedule-calendar.styles";

interface Props {
  date?: Date;
  disabled?: boolean;
  onChange?: (selected: Date) => void;
  onStep?: (step: number) => void;
}

function ScheduleCalendar(props: Props) {
  const wrapperRef = useRef(null);
  const selectRef = useRef(null);
  const classes = useStyles();
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const month = props.date
    ? format(props.date, "MMMM")
    : format(new Date(), "MMMM");

  const handleOpenCalendar = () => {
    setIsCalendarOpen(true);
  };

  const handleCloseCalendar = () => {
    setIsCalendarOpen(false);
  };

  const handleStepClick = (step: number) => {
    props.onStep?.(step);
  };

  const handleCalendarApply = (days: daysMonth[]) => {
    setIsCalendarOpen(false);
    props.onChange?.(days[0].date);
  };

  useOutsideClick(wrapperRef, handleCloseCalendar, ["MuiMenuItem-root"]);

  return (
    <Grid item container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography className={classes.title}>Available Dates</Typography>
      </Grid>
      <Grid item container className={classes.monthWrapper}>
        <IconButton
          disabled={props.disabled}
          onClick={() => handleStepClick(-1)}
          className={classes.controlButton}
        >
          <ChevronLeft />
        </IconButton>
        <Button
          disabled={props.disabled}
          onClick={handleOpenCalendar}
          className={classes.button}
        >
          <Typography className={classes.month}>{month}</Typography>
        </Button>
        <IconButton
          disabled={props.disabled}
          onClick={() => handleStepClick(1)}
          className={classes.controlButton}
        >
          <ChevronRight />
        </IconButton>
      </Grid>
      {isCalendarOpen && (
        <Calendar
          initialMonth={month}
          selectRef={selectRef}
          wrapperRef={wrapperRef}
          multiWeekSelection={false}
          disablePast={false}
          onApply={handleCalendarApply}
        />
      )}
    </Grid>
  );
}

export default ScheduleCalendar;
